import {
  DataTable,
  DateField,
  List,
  NumberField,
  TextField,
} from "@/components/admin"

const MaterialList: React.FC = () => {
  return (
    <List perPage={50}>
      <DataTable bulkActionButtons={false}>
        <DataTable.Col source="name" label="Nom" field={TextField} />
        <DataTable.Col source="category" label="Catégorie" field={TextField} />
        <DataTable.Col source="unit" label="Unité" field={TextField} />
        <DataTable.Col
          source="cost_per_unit"
          label="Prix"
          field={NumberField}
        />
        <DataTable.Col source="created_at" label="Créé le" field={DateField} />
      </DataTable>
    </List>
  )
}

export default MaterialList
